export default __webpack_public_path__ + "static/get-debt-help-ccc4fca54dcef58ca820907621b66208.svg";